<!-- T11 — Fullscreen loading overlay -->
<div
  *ngIf="state?.isVisible"
  class="loading-overlay"
  role="status"
  aria-live="polite"
>
  <div class="loading-overlay__spinner" aria-hidden="true"></div>
  <div *ngIf="state?.message" class="loading-overlay__message">
    {{ state?.message }}
  </div>
</div>
